import React, {useState} from 'react';
import {BaseInputProps} from '../..';

import {useFieldArray, useFormContext} from 'react-hook-form';

import {Container, Row, Index, Title, CenterdColumn} from './styles';
import {NestedKeys} from 'shared/types/key-manipulation';
import {GetSpotlightOptionsProps} from '../dynamic-section';
import IconButton from 'shared/migration-components/icon-button';
import {IoAdd, IoSearch} from 'react-icons/io5';
import {Spotlight, spotlight} from '@mantine/spotlight';
import {useDebounce} from 'use-debounce';
import Loading from 'shared/migration-components/loading';

export interface ListSectionProps<T = any> extends BaseInputProps {
  name: NestedKeys<T>;
  index?: number;
  card: React.FC<any>;
  onCreate?: {
    title: string;
    spotlightOptions: GetSpotlightOptionsProps;
    placeholder?: string;
  };
}

const ListSection: React.FC<ListSectionProps> = ({
  name,
  label,
  index,
  card: Card,
  disabled = false,
  onCreate,
}) => {
  const {control} = useFormContext();
  const {fields, append, remove} = useFieldArray({
    control,
    name: name as string,
  });
  const [search, setSearch] = useState<string | undefined>();
  const [debouncedSearch] = useDebounce(search, 1000);

  const onSpotlightClick = (data: any) => {
    append(data);
    spotlight.close();
  };

  const {data, isLoading} = onCreate?.spotlightOptions
    ? onCreate.spotlightOptions(debouncedSearch)
    : ({} as ReturnType<GetSpotlightOptionsProps>);

  return (
    <Container>
      <Row>
        {index && <Index>{index}</Index>}
        <Title>{label}</Title>
        {onCreate && (
          <IconButton
            icon={<IoAdd />}
            label="Adicionar"
            variant="filled"
            onClick={() => spotlight.open()}
          />
        )}
      </Row>
      {fields.map((field, index) => (
        <Card
          key={index}
          {...{...field, remove: () => remove(index), disabled}}
        />
      ))}
      {onCreate && (
        <Spotlight
          actions={(typeof onCreate.spotlightOptions !== 'function'
            ? onCreate.spotlightOptions
            : data ?? [])!.map((option, index) => ({
            ...option,
            id: String(index),
            onClick: () => onSpotlightClick(option.value),
          }))}
          limit={8}
          onQueryChange={setSearch}
          query={search}
          filter={(_, actions) => actions}
          searchProps={{
            leftSection: <IoSearch />,
            placeholder: onCreate.placeholder ?? 'Pesquisar...',
          }}
          nothingFound={
            search && (
              <>
                {(isLoading || !data) && (
                  <CenterdColumn>
                    <Loading />
                  </CenterdColumn>
                )}
                {!isLoading && data?.length === 0 && (
                  <CenterdColumn>Nenhum registro encontrado...</CenterdColumn>
                )}
              </>
            )
          }
        />
      )}
    </Container>
  );
};

export default ListSection;
